// File Metadata:
// Filename: Layout.js
// Version: 1.00
// Created: 2022-08-23 21:27:27
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Outlet } from 'react-router-dom'
import DashHeader from './DashHeader'
import ResponsiveAppBar from './ResponsiveNav'

const Layout = () => {
	return (
		<main className='App'>
			<DashHeader />
			<Outlet />
		</main>
	)
}

export default Layout
